// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"2d4f79fe","123":"bb956bad","2376":"bb956bad","2513":"2d4f79fe","3215":"be6915de","4121":"36048e26","5095":"bb956bad","6619":"2d4f79fe","9101":"2d4f79fe","9194":"bb956bad"}[chunkId] + ".chunk.css";
};